import React, { useState, useEffect } from 'react';
import './Profile.css';

const Profile = () => {
  const userId = localStorage.getItem('user_id');
  const [userInfo, setUserInfo] = useState({
    username: '',
    phone: '',
    avatar: ''
  });

  const [newUsername, setNewUsername] = useState('');
  const [preview, setPreview] = useState('');
  const [base64, setBase64] = useState('');

  // 获取用户信息
  useEffect(() => {
    const fetchInfo = async () => {
      const res = await fetch(`http://111.229.118.87:5000/api/user/info?user_id=${userId}`);
      const data = await res.json();
      if (data.code === 200) {
        setUserInfo(data.data);
        setNewUsername(data.data.username);
        setPreview(data.data.avatar);
      }
    };
    fetchInfo();
  }, [userId]);

  // 选择图片 → 校验尺寸+大小 → 生成base64 → 预览
  const handleSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // 大小限制 35KB
    if (file.size > 35 * 1024) {
      alert('图片不能超过 35KB！');
      return;
    }

    const img = new Image();
    const url = URL.createObjectURL(file);
    img.src = url;

    img.onload = () => {
      const w = img.width;
      const h = img.height;

      // 尺寸限制 510x510
      if (w > 510 || h > 510) {
        alert('图片尺寸不能超过 510px × 510px！');
        return;
      }

      // 转 Base64
      const reader = new FileReader();
      reader.onloadend = () => {
        const b64 = reader.result;
        setBase64(b64);
        setPreview(b64);
      };
      reader.readAsDataURL(file);
    };
  };

  // 上传头像（存入数据库）
  const handleUpload = async () => {
    if (!base64) {
      alert('请先选择图片');
      return;
    }

    const res = await fetch('http://你的服务器IP:8000/api/user/upload-avatar', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userId,
        avatar: base64
      })
    });

    const data = await res.json();
    if (data.code === 200) {
      alert('头像上传成功！');
      setUserInfo({ ...userInfo, avatar: base64 });
    } else {
      alert(data.msg);
    }
  };

  // 修改用户名
  const saveName = async () => {
    if (!newUsername) {
      alert('请输入用户名');
      return;
    }
    const res = await fetch('http://你的服务器IP:8000/api/user/edit-name', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userId,
        username: newUsername
      })
    });
    const data = await res.json();
    if (data.code === 200) {
      alert('用户名修改成功');
      setUserInfo({ ...userInfo, username: newUsername });
    }
  };

  return (
    <div className="profile-container">
      <div className="box">
        <h2>个人中心</h2>

        {/* 头像区域 */}
        <div className="avatar-section">
          <img src={preview || 'default.png'} alt="avatar" className="avatar" />
          <div className="btn-group">
            <input type="file" accept="image/*" id="file" onChange={handleSelect} />
            <label htmlFor="file" className="btn">选择图片</label>
            <button className="btn upload" onClick={handleUpload}>上传保存</button>
          </div>
          <div className="tip">
            要求：510px×510px 以内，大小 ≤35KB
          </div>
        </div>

        {/* 用户名 */}
        <div className="item">
          <label>用户名</label>
          <input
            value={newUsername}
            onChange={(e) => setNewUsername(e.target.value)}
          />
          <button onClick={saveName}>保存</button>
        </div>

        {/* 手机号 */}
        <div className="item">
          <label>手机号</label>
          <span>{userInfo.phone}</span>
        </div>
      </div>
    </div>
  );
};

export default Profile;